import { Stack, SvgIconProps } from '@mui/material';
import { LogoView } from './LogoView';
import themeConfig from 'settings/branding';

export const MainLogo = (props: SvgIconProps) => {
  return (
    <Stack
      sx={{
        backgroundColor: 'background.paper',
        padding: 0.5,
        borderRadius: '6px',
        marginTop: 3.5,
      }}
    >
      <LogoView src={themeConfig?.logoUrl} height={24} width={24} />
    </Stack>
  );
};
